import React from 'react';
import {Link} from 'react-router-dom';
import {PROTECTED_APP} from 'constants/pageRoutes';

import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

import ButtonComponent from 'components/buttons/button';
import IntlMessageComponent from 'components/formatters/intlMessage';
import PageSubTitleViewComponent from 'components/pageTitle/subTitle';

export default function PaymentDeclinedComponent() {
  return (
    <React.Fragment>
      <PageSubTitleViewComponent id="page.payment.decline.title" />
      
      <Typography variant="body1">
        <IntlMessageComponent id="page.payment.decline.description" />
      </Typography>
      
      <Box mt={5}>
          <ButtonComponent
            color="primary"
            variant="contained"
            component={Link}
            to={PROTECTED_APP}
          ><IntlMessageComponent id="page.payment.button.dashboard" /></ButtonComponent>
        </Box>
    </React.Fragment>
  );
}
